import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';

import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import { CheckboxField } from './../../../../../../components/fields';
import { errorMessages, minLength8 } from './../../../../../../utilities/validation';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { createBankRecord, updateBankRecord, deleteBankRecord, getBanks } from '../../../../../../reducers/banking';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import Bank from '../../../../../../components/forms/bank';
import mixpanel from 'mixpanel-browser';
import { bankingCheckPreferenceField, bankRoutingFieldValidate } from '../../../../../../utilities/regime';
class EmployeeDirectDepositStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'EmployeeDirectDepositStep' } });

        const { role, job, banks, getSignatures, setProgressionProperties, getBanks } = this.props;
        getSignatures(role, result =>
            setProgressionProperties({
                directDepositCheckPreference: result.find(s => s.name === `${Signatures.types.DIRECT_DEPOSIT_PREFEERENCES.name}:${job.id}`) !== undefined
            })
        );

        if (!banks) {
            getBanks(role);
        }
    }

    submit(values, action) {
        const { role, job, sign, createBankRecord, updateBankRecord, setProgressionProperties, deleteBankRecord, progression, getBanks, bank } = this.props;
        const { bankName, bankRouting, checkingAccount } = values;
        const { id } = bank || {};
        const { directDepositCheckPreference } = progression;

        if (directDepositCheckPreference === true && values.bankingCheckPreference === true) {
            if (id) {
                deleteBankRecord(id, () => action());
            } else {
                action();
            }
            return;
        }

        if (directDepositCheckPreference !== true && values.bankingCheckPreference === true) {
            sign(role, `${Signatures.types.DIRECT_DEPOSIT_PREFEERENCES.name}:${job.id}`, () => {
                setProgressionProperties({ directDepositCheckPreference: true });
                if (id) {
                    deleteBankRecord(id, () => action());
                } else {
                    action();
                }
            });
            return;
        }

        setProgressionProperties({ directDepositCheckPreference: false });
        let persistData = id ? updateBankRecord : createBankRecord;
        let data = { id, name: bankName, routing: bankRouting, account: checkingAccount, primary: true };
        persistData(data, role, () => getBanks(role, action));
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, banks, bankingCheckPreference, progression, changeField, regime } = this.props;
        if (!banks || !progression || progression.directDepositCheckPreference === undefined) {
            return null;
        }

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'directDeposit.intro'}
                            defaultMessage={"Setting up direct deposit for payments is critical. Let's take care of that to insure you get paid promptly!"}
                        />
                    </div>
                </div>
                <Bank regime={regime} disabled={!!bankingCheckPreference} manuallyValidated={true} />
                {bankingCheckPreferenceField(regime) && (
                    <div className="row">
                        <div className="col-xs-12 col-sm-8">
                            <Field
                                name="bankingCheckPreference"
                                component={CheckboxField}
                                checked={bankingCheckPreference === true}
                                onChange={e => {
                                    let value = e.target.value !== 'true' ? 'n/a' : null;
                                    changeField(formSettings.form, 'bankName', value);
                                    changeField(formSettings.form, 'bankRouting', value);
                                    changeField(formSettings.form, 'checkingAccount', value);
                                }}
                                placeholder={messages.bankingCheckPreference}
                            />
                        </div>
                    </div>
                )}
                <WizardButtons disabled={submitting} back={{ action: back }} />
            </form>
        );
    }
}

EmployeeDirectDepositStep = reduxForm({
    ...formSettings,
    validate: (values, props) => {
        if (values.bankingCheckPreference === true) {
            return {};
        }

        const errors = {};
        errors.bankName = values.bankName ? undefined : errorMessages.required();
        errors.bankRouting = values.bankRouting ? bankRoutingFieldValidate(props.regime)(values.bankRouting) : errorMessages.required();
        errors.checkingAccount = values.checkingAccount ? minLength8(values.checkingAccount) : errorMessages.required();
        return errors;
    }
})(EmployeeDirectDepositStep);

const selector = formValueSelector(formSettings.form);
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    let banks = state.banking.banks;
    let bank = banks && banks.length > 0 ? banks[banks.length - 1] : undefined;

    let bankingCheckPreference = progression !== undefined && progression.directDepositCheckPreference;
    let values = {};
    if (bankingCheckPreference === true && !bank) {
        values = {
            bankingCheckPreference,
            bankName: 'n/a',
            bankRouting: 'n/a',
            checkingAccount: 'n/a'
        };
    } else {
        values = {
            id: bank && bank.id ? bank.id : undefined,
            bankName: bank && bank.name ? bank.name : undefined,
            bankRouting: bank && bank.routing ? bank.routing : undefined,
            checkingAccount: bank && bank.account ? bank.account : undefined,
            bankingCheckPreference: false
        };
    }

    return {
        role: state.identity.role,
        job: state.onboarding.job,
        regime: (state.jobs.list || [{}])[0].regime,
        banks,
        bank,
        progression,
        bankingCheckPreference: selector(state, 'bankingCheckPreference') && selector(state, 'bankingCheckPreference') === true,
        initialValues: { ...values }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            changeField: change,
            getBanks: getBanks,
            createBankRecord: createBankRecord,
            updateBankRecord: updateBankRecord,
            deleteBankRecord: deleteBankRecord,
            getSignatures: getSignatures,
            sign: sign,
            setProgressionProperties: setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDirectDepositStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/employeeDirectDeposit.jsx